// ── Request Types ─────────────────────────────────────────────

export enum InputType {
  OpenApi = 0,
  SqlSchema = 1,
  AutoDetect = 2
}

export enum GeneratorTarget {
  DotNet = 0,
  Java = 1,
  Both = 2
}

export enum DatabaseProvider {
  SqlServer = 0,
  PostgreSQL = 1,
  MySQL = 2,
  SQLite = 3
}

export interface GenerateRequest {
  inputJson?: any;
  inputSql?: string;
  inputType: InputType;
  target: GeneratorTarget;
  rootNamespace: string;
  rootPackage: string;
  databaseProvider: DatabaseProvider;
  includeDbContext: boolean;
  includeSwagger: boolean;
  includeErrorHandling: boolean;
  ciCdTool: CiCdTool; 
}

// ── Response Types ────────────────────────────────────────────

export interface GenerateResponse {
  projectName: string;
  totalFiles: number;
  target: string;
  generatedAt: string;
  downloadUrl: string;
  generatedFiles: string[];
  success: boolean;
  errorMessage?: string;
  ciCdTool: CiCdTool;
}

export interface HealthResponse {
  status: string;
  version: string;
  timestamp: string;
  service: string;
}

// ── UI Types ──────────────────────────────────────────────────

export interface GeneratorFormState {
  input: string;
  inputType: InputType;
  target: GeneratorTarget;
  rootNamespace: string;
  rootPackage: string;
  databaseProvider: DatabaseProvider;
  includeDbContext: boolean;
  includeSwagger: boolean;
  includeErrorHandling: boolean;
  ciCdTool: CiCdTool; 
}

export type TabType = 'openapi' | 'sql';

export enum CiCdTool {
  None = 0,
  GitHubActions = 1,
  AzureDevOps = 2
}